import { CreditCardUtil } from '@xengage/gw-portals-util-js';

export default {
    // Platform CreditCardUtil functions
    getInputMaskForIssuerCode: CreditCardUtil.getInputMaskForIssuerCode,
    getDefaultCardMask: CreditCardUtil.getDefaultCardMask
};
